import React, { useState } from "react";
import LoadingSpinner from "./spinner";
import CelluleUrlSite from "./celluleUrlSite";
import getInfoThemeActif from "./infoThemeActif";
import "../style/drawer.scss";
import "../style/itemsList.scss";
import TableTheme from "./TableTheme";
import ThemeDetailDrawer from "./ThemesDrawer";
import useSortableData from "../utils/customHookSortTable";
import BasicButtons from "./buttonChoice";


const FTPComponentThemes = ({ filteredThemes, handleSort, isLoading, error, handlePluginButtonClick, handleSiteButtonClick, handleThemeButtonClick,role,handleCVEButtonClick}) => {
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const { requestSort } = useSortableData(filteredThemes);

  const handleRowClick = (index) => {
    setSelectedRowIndex(index);
  };

  const handleCloseDrawer = () => {
    setSelectedRowIndex(null);
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return <div>Erreur lors de la récupération des données FTP</div>;
  }
  return (
    <>
      <BasicButtons
          place="theme"
          onSiteButtonClick={handleSiteButtonClick}
          onPluginButtonClick={handlePluginButtonClick}
          onThemeButtonClick={handleThemeButtonClick}
          onCVEButtonClick={handleCVEButtonClick}
          role={role}
      />
      <TableTheme
        data={filteredThemes}
        handleSort={handleSort}
        role={role}
        handleRowClick={handleRowClick}
        CelluleUrlSite={CelluleUrlSite}
        getInfoThemeActif={getInfoThemeActif}
      />

      <ThemeDetailDrawer
        selectedRowIndex={selectedRowIndex}
        handleCloseDrawer={handleCloseDrawer}
        filteredThemes={filteredThemes}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        requestSort={requestSort}
        role={role}
      />
    </>
  );
};

export default FTPComponentThemes;
